(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["purmoon-testimonials-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pm-testimonials-carousel')) {
  customElements.define('pm-testimonials-carousel', class extends HTMLElement {
    connectedCallback() {
      this.offset = this.offset || 0;
      this.userPaused = false;
      this.hovered = false;
      this.focused = false;
      this.editorSelected = false;
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = matchMedia('(max-width: 749px)');
      this.reducedMotion.addEventListener('change', () => {
        this.updatePauseButton(); this.updateAnimationPause();
      }, options);
      document.addEventListener('visibilitychange', () => this.updateAnimationPause(), options);
      this.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'touch') this.hovered = true;
        this.updateAnimationPause();
      }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; this.updateAnimationPause(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.updateAnimationPause(); }, options);
      this.addEventListener('focusout', event => {
        this.focused = this.contains(event.relatedTarget);
        this.updateAnimationPause();
      }, options);
      this.addEventListener('click', event => {
        if (event.target.closest('[data-pm-testimonial-next]')) this.move(1);
        if (event.target.closest('[data-pm-testimonial-prev]')) this.move(-1);
        if (event.target.closest('[data-pm-pause]')) {
          this.userPaused = !this.userPaused;
          this.updatePauseButton();
          this.updateAnimationPause();
        }
      }, options);
      this.addEventListener('shopify:block:select', event => {
        this.editorSelected = true;
        this.build();
        const card = this.originals?.find(item => item.dataset.pmBlockId === event.detail.blockId);
        if (card && this.period) {
          this.manual = null;
          this.offset = card.getBoundingClientRect().left - this.first.getBoundingClientRect().left;
          this.render();
        }
      }, options);
      this.addEventListener('shopify:block:deselect', () => { this.editorSelected = false; this.updateAnimationPause(); }, options);
      this.addEventListener('shopify:section:select', () => { this.editorSelected = true; this.updateAnimationPause(); }, options);
      this.addEventListener('shopify:section:deselect', () => { this.editorSelected = false; this.updateAnimationPause(); }, options);
      this.queueBuild = () => {
        cancelAnimationFrame(this.buildFrame);
        this.buildFrame = requestAnimationFrame(() => this.build());
      };
      this.resizeObserver = new ResizeObserver(this.queueBuild);
      this.resizeObserver.observe(this);
      if (document.fonts) {
        document.fonts.ready.then(() => { if (this.isConnected) this.queueBuild(); });
        document.fonts.addEventListener('loadingdone', this.queueBuild, options);
      }
      this.queueBuild();
      this.tick = time => {
        if (!this.isConnected) return;
        if (this.period > 0) {
          this.updateAnimationPause(time);
          if (this.manual) {
            const progress = Math.min((time - this.manual.started) / 320, 1);
            const ease = 1 - Math.pow(1 - progress, 3);
            this.offset = this.manual.from + this.manual.distance * ease;
            if (progress === 1) this.manual = null;
            this.render();
          }
        }
        // Automatic movement is entirely the CSS keyframe animation.
        // This frame only handles arrow easing and pause/resume state.
        this.animationFrame = requestAnimationFrame(this.tick);
      };
      this.animationFrame = requestAnimationFrame(this.tick);
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.buildFrame);
      cancelAnimationFrame(this.animationFrame);
      this.resizeObserver?.disconnect();
      this.abortController?.abort();
      this.manual = null;
    }

    cloneCard(card) {
      const clone = card.cloneNode(true);
      clone.classList.add('pm-testimonials__card--clone');
      clone.setAttribute('data-pm-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('inert', '');
      for (const element of [clone, ...clone.querySelectorAll('*')]) {
        element.removeAttribute('id');
        for (const attribute of Array.from(element.attributes)) {
          if (attribute.name.startsWith('data-shopify')) element.removeAttribute(attribute.name);
        }
      }
      clone.removeAttribute('data-pm-block-id');
      return clone;
    }

    build() {
      this.track = this.querySelector('[data-pm-testimonial-track]');
      this.first = this.querySelector('[data-pm-group="first"]');
      this.second = this.querySelector('[data-pm-group="second"]');
      const viewport = this.querySelector('.pm-testimonials__viewport');
      if (!this.track || !this.first || !this.second || !viewport) return;
      this.first.querySelectorAll('[data-pm-clone]').forEach(card => card.remove());
      this.originals = Array.from(this.first.children);
      if (!this.originals.length) { this.period = 0; return; }
      const previousStep = this.step;
      const oldOffset = this.offset;
      const sequenceWidth = this.first.getBoundingClientRect().width;
      const viewportWidth = viewport.getBoundingClientRect().width;
      if (sequenceWidth <= 0 || viewportWidth <= 0) return;
      const gap = parseFloat(getComputedStyle(this.first).columnGap) || 0;
      this.step = this.originals[0].getBoundingClientRect().width + gap;
      this.sequenceWidth = sequenceWidth;
      const repetitions = Math.max(1, Math.ceil((viewportWidth + 1) / sequenceWidth));
      const copies = document.createDocumentFragment();
      for (let i = 1; i < repetitions; i++) {
        this.originals.forEach(card => copies.appendChild(this.cloneCard(card)));
      }
      this.first.appendChild(copies);
      this.second.replaceChildren(...Array.from(this.first.children, card => this.cloneCard(card)));
      this.period = this.first.getBoundingClientRect().width;
      const seconds = Number(this.mobile.matches ? this.dataset.mobileSpeed : this.dataset.speed) || 38;
      this.durationMs = seconds * this.period / this.sequenceWidth * 1000;
      this.track.style.setProperty('--pm-loop-distance', `${this.period}px`);
      this.track.style.setProperty('--pm-loop-duration', `${this.durationMs / 1000}s`);
      this.animation = this.track.getAnimations()[0];
      this.offset = previousStep ? oldOffset * this.step / previousStep : oldOffset;
      this.manual = null;
      const controls = this.querySelector('[data-pm-controls]');
      if (controls) controls.hidden = false;
      this.updatePauseButton();
      this.updateAnimationPause();
      this.render();
    }

    get offset() {
      if (this.pendingOffset !== null && this.pendingOffset !== undefined) return this.pendingOffset;
      if (this.animation && this.durationMs > 0 && this.period > 0) {
        return (((Number(this.animation.currentTime) || 0) % this.durationMs) / this.durationMs) * this.period;
      }
      return this.savedOffset || 0;
    }

    set offset(value) { this.pendingOffset = value; }

    render() {
      if (!this.animation || !(this.period > 0)) return;
      this.updateAnimationPause();
      const position = ((this.offset % this.period) + this.period) % this.period;
      // Seek within the existing CSS animation; never override its transform.
      this.animation.currentTime = position / this.period * this.durationMs;
      this.savedOffset = position;
      this.pendingOffset = null;
    }

    updateAnimationPause(time = performance.now()) {
      if (!this.track) return;
      const paused = this.dataset.autoScroll === 'false' || this.reducedMotion.matches ||
        this.userPaused || this.hovered || this.focused || this.editorSelected ||
        document.hidden || this.manual || time < (this.resumeAt || 0);
      const state = paused ? 'paused' : 'running';
      const currentTime = this.animation?.currentTime;
      if (this.track.style.animationPlayState !== state) this.track.style.animationPlayState = state;
      // Synchronize immediately so an arrow seek cannot gain an extra frame.
      if (this.animation && paused && (this.animation.playState !== 'paused' || this.animation.pending)) {
        this.animation.pause();
        if (currentTime !== null && currentTime !== undefined) this.animation.currentTime = currentTime;
      }
      if (this.animation && !paused && this.animation.playState !== 'running') this.animation.play();
    }

    move(direction) {
      if (!(this.period > 0) || !(this.step > 0)) return;
      this.resumeAt = performance.now() + 2500;
      if (this.reducedMotion.matches) {
        this.manual = null;
        this.offset += direction * this.step;
        this.render();
      } else {
        const destination = (this.manual ? this.manual.from + this.manual.distance : this.offset) + direction * this.step;
        this.manual = { from: this.offset, distance: destination - this.offset, started: performance.now() };
      }
      this.updateAnimationPause();
    }

    updatePauseButton() {
      const button = this.querySelector('[data-pm-pause]');
      if (!button) return;
      button.hidden = this.reducedMotion.matches;
      button.textContent = this.userPaused ? 'Play' : 'Pause';
      button.setAttribute('aria-label', this.userPaused ? 'Resume automatic review scrolling' : 'Pause automatic review scrolling');
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
